module.exports = __webpack_public_path__ + "img/order-status-bg.04d85b6a.png";